import type { FerryIngredient } from '@apps/main/modules/recipe/ingredients';

import type { IngredientSerializer } from '../..';

import { serializeFerry } from './serialize';
import { deserializeFerry } from './deserialize';

export const FerrySerializer: IngredientSerializer<FerryIngredient> = {
  serialize: (ferry: FerryIngredient): string => serializeFerry(ferry),

  deserialize: (value: string): FerryIngredient => deserializeFerry(value),
};

export { FERRY_INGREDIENT_SUFFIX } from './constants';
